<template>
    <div :class="noticeClasses">
        <div class="gh-notice__icon">
            <slot name="icon">
                <img src="https://d9hv9sikl36u8.cloudfront.net/images/dashboard/portal-icons-warning.svg" alt="">
            </slot>
        </div>
        <div class="gh-notice__text">
            <slot name="text">
                <div v-html="text"></div>
            </slot>
        </div>
        <div class="gh-notice__actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String
            },

            customClass: {
                type: String,
                default: ''
            }
        },

        computed: {
            noticeClasses() {
                return `gh-notice ${this.customClass}`;
            }
        }
    }
</script>
